import React from 'react';
import { useLocation } from 'react-router-dom';
import { SignUp } from '../auth/clerk';
import { useTheme } from '../context/ThemeContext';
import Wordmark from '../components/Brand/Wordmark';

/**
 * Sign-up page using Clerk's SignUp component.
 */
function SignUpPage() {
  const { theme } = useTheme();
  const { search } = useLocation();
  const invited = new URLSearchParams(search).get('invite');

  return (
    <div className={`auth-page ${theme}`}>
      <div className="auth-container">
        <div className="auth-header">
          <h1 className="auth-wordmark-heading">
            <Wordmark placement="auth" className="auth-wordmark" />
          </h1>
          <p className="auth-invite-note">Beta is invite-only. Use the invitation you were sent to create your account.</p>
          {invited ? (
            <p className="auth-invite-note">This link records who invited you. You still need the invitation that lets you create an account.</p>
          ) : null}
        </div>
        <SignUp
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          forceRedirectUrl="/projects"
          fallbackRedirectUrl="/projects"
          signInFallbackRedirectUrl="/projects"
          appearance={{
            elements: {
              rootBox: 'clerk-root-box',
              card: 'clerk-card',
            }
          }}
        />
      </div>
    </div>
  );
}

export default SignUpPage;
